import {
	SET_CODEMANAGER,
	SET_RELOAD_CODEMANAGER,
	SET_CODESELECTED,
	SET_CODESELECTED_DETAILS,
	RESET_CODESELECTED,
	SET_SHOWMODAL,
	SET_SHOWFORMSMODAL,
	SET_SHOW_CODE_DETAIL_MODAL,
	SET_RESET_SNIPPET,
	TOAST_MESSAGES_PUSH
} from './mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';
import _ from 'lodash';

const initialState = {
	codeManager: {},
	reloadCodeManager: false,
	codeSelected: {},
	codeSelectedDetails: {},
	showModal: false,
	showFormsModal: false,
	showCodeDetailModal: false,
	resetSnippet: false
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'codemanager',
	namespaced: true,
	state: { ...initialState },
	mutations: {
		[SET_CODEMANAGER](state, codeManager) {
			state.codeManager = codeManager;
		},
		[SET_RELOAD_CODEMANAGER](state, value) {
			state.reloadCodeManager = value;
		},
		[SET_CODESELECTED](state, codeSelected) {
			state.codeSelected = codeSelected;
		},
		[SET_CODESELECTED_DETAILS](state, codeSelectedDetail) {
			state.codeSelectedDetails = codeSelectedDetail;
		},
		[RESET_CODESELECTED](state) {
			state.codeSelected = {};
		},
		[SET_SHOWMODAL](state, value) {
			state.showModal = value;
		},
		[SET_SHOWFORMSMODAL](state, value) {
			state.showFormsModal = value;
		},
		[SET_SHOW_CODE_DETAIL_MODAL](state, value) {
			state.showCodeDetailModal = value;
		},
		[SET_RESET_SNIPPET](state, value) {
			state.resetSnippet = value;
		}
	},
	actions: {
		async loadCodeManager({ dispatch, commit, state }, parameters) {
			const { page, saveOnStore } = parameters;
			if (page === 1 && saveOnStore) {
				commit(SET_CODEMANAGER, {});
			}
			if (parameters.saveOnStore) {
				delete parameters.saveOnStore;
			}
			let results = {};
			await api
				.get(buildRoute('/snippets', parameters))
				.then(res => {
					if (saveOnStore) {
						if (_.isEmpty(state.codeManager)) {
							commit(SET_CODEMANAGER, res);
							results = res;
						} else {
							let currentStore = _.cloneDeep(state.codeManager);
							let codeManagerPayload = mergePayloadObjects(
								currentStore,
								res
							);
							commit(SET_CODEMANAGER, codeManagerPayload);
							results = codeManagerPayload;
						}
					} else {
						results = res;
					}
				})
				.catch(error => {
					if (error) {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: 'An error occurred. Please try again.'
							},
							{
								root: true
							}
						);
					}
				});
			commit(SET_RELOAD_CODEMANAGER, false);
			return results;
		},
		reloadCodeManager({ commit }) {
			commit(SET_RELOAD_CODEMANAGER, true);
		},
		codeSelected({ commit }, value) {
			commit(SET_CODESELECTED, value);
		},
		codeSelectedDetails({ commit }, value) {
			commit(SET_CODESELECTED_DETAILS, value);
		},
		resetCodeSelected({ commit }) {
			commit(RESET_CODESELECTED);
		},
		showModal({ commit }, value) {
			commit(SET_SHOWMODAL, value);
		},
		showFormsModal({ commit }, value) {
			commit(SET_SHOWFORMSMODAL, value);
		},
		showCodeDetailModal({ commit }, value) {
			commit(SET_SHOW_CODE_DETAIL_MODAL, value);
		},
		resetSnippet({ commit }, value) {
			commit(SET_RESET_SNIPPET, value);
		}
	},
	getters: {
		codeManager: state => state.codeManager,
		reloadCodeManager: state => state.reloadCodeManager,
		codeSelected: state => state.codeSelected,
		codeSelectedDetails: state => state.codeSelectedDetails,
		showModal: state => state.showModal,
		showFormsModal: state => state.showFormsModal,
		showCodeDetailModal: state => state.showCodeDetailModal,
		resetSnippet: state => state.resetSnippet
	}
};
